import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { Observable } from 'rxjs';

@Injectable()
export class AdminMobileappService {

  constructor(private http: HttpClient
    , private sharedService: SharedService) { }


  ServiceUrl: string = SharedService.BaseMobileServiceUrl + "WebAppData/";
  // For Admin Authentication
  httpOptions = {
    headers: new HttpHeaders({
      'Authorization': 'Basic ' + this.sharedService.getAdminTokenAtLocStorage()
    })
  };


  public search(searchGridEntity: any): Observable<any> {
    searchGridEntity.ApiKey = this.sharedService.getAdminTokenAtLocStorage();
    let searchUrl = this.ServiceUrl + "AdminPrasadOrder/Search";
    //let searchUrl = "https://localhost:7108/api/WebAppData/AdminPrasadOrder/Search";
    return this.http.post<any>(searchUrl, searchGridEntity);
  }

  public searchByPONo(searchGridEntity: any): Observable<any> {
    searchGridEntity.ApiKey = this.sharedService.getAdminTokenAtLocStorage();
    let searchUrl = this.ServiceUrl + "AdminPrasadOrder/SearchById";
    //let searchUrl="https://localhost:7108/api/WebAppData/AdminPrasadOrder/SearchById";
    return this.http.post<any>(searchUrl, searchGridEntity);
  }

  public getDispatchedOrders(): Observable<any> {
    var request = { ApiKey: this.sharedService.getAdminTokenAtLocStorage() };
    let searchUrl = this.ServiceUrl + "AdminPrasadOrder/Search/Dispached";
    //let searchUrl = "https://localhost:7108/api/WebAppData/AdminPrasadOrder/Search/Dispached";
    return this.http.post<any>(searchUrl, request);
  }

  public devoteeSearch(searchEntity: any): Observable<any> {
    searchEntity.ApiKey = this.sharedService.getAdminTokenAtLocStorage();
    let searchUrl = this.ServiceUrl + "Admin/Devotee/Search";
    //let searchUrl = "https://testapi.pujaprasad.in/api/" + "WebAppData/" + "Admin/Devotee/Search"
    return this.http.post<any>(searchUrl, searchEntity);
  }

  public updateDispatchedOrders(updateEntity: any): Observable<any> {
    updateEntity.ApiKey = this.sharedService.getAdminTokenAtLocStorage();
    let searchUrl = this.ServiceUrl + "Admin/PrasadOrder/Update/DispatchDone";
    //let searchUrl = "https://localhost:7108/api/WebAppData/Admin/PrasadOrder/Update/DispatchDone";
    return this.http.post<any>(searchUrl, updateEntity);
  }

  public updatePrasaOrderPaymentDone(prasadOrderNo: number): Observable<any> {
    var updateEntity = {
      ApiKey: this.sharedService.getAdminTokenAtLocStorage(),
      PrasadOrderNo: prasadOrderNo
    }
    //let searchUrl = this.ServiceUrl + "Admin/Devotee/Search";
    //let baseUrl = "https://testapi.pujaprasad.in/api/" + "WebAppData/";
    //let baseUrl = "https://localhost:7108/api/" + "WebAppData/";

    let searchUrl = this.ServiceUrl + "Admin/PrasadOrder/Update/PaymentDone"
    return this.http.post<any>(searchUrl, updateEntity);
  }

  public deleteMobilePrasadOrder(prasadOrderNo: number): Observable<any> {
    var updateEntity = {
      ApiKey: this.sharedService.getAdminTokenAtLocStorage(),
      PrasadOrderNo: prasadOrderNo
    }

    let searchUrl = this.ServiceUrl + "Admin/PrasadOrder/Delete";
    return this.http.post<any>(searchUrl, updateEntity);
  }

  public whatsAppMsgSend(whatsAppMsgRequest: any): Observable<any> {
    whatsAppMsgRequest.ApiKey = this.sharedService.getAdminTokenAtLocStorage();
    let searchUrl = this.ServiceUrl + "Admin/WhatsAppMsgSend";
    //let searchUrl = "https://localhost:7108/api/WebAppData/Admin/WhatsAppMsgSend";
    return this.http.post<any>(searchUrl, whatsAppMsgRequest);
  }

  // public multiWhatsAppMsgSend(multiWhatsAppMsgRequest: any): Observable<any> {
  //   multiWhatsAppMsgRequest.ApiKey = this.sharedService.getAdminTokenAtLocStorage();
  //   let baseUrl = "https://localhost:7108/api/WebAppData/";
  //   //let searchUrl = this.ServiceUrl + "Admin/MultiWhatsAppMsgSend";
  //   let searchUrl = baseUrl + "Admin/MultiWhatsAppMsgSend";
  //   return this.http.post<any>(searchUrl, multiWhatsAppMsgRequest);
  // }

}



// WEBPACK FOOTER //
// ./src/app/admin/services/admin-mobileapp.service.ts